import { useSelector } from 'react-redux';
import { APIHookResponse } from '~/api/types';
import { isVerified, verifiedError } from '~/store/auth/selectors';

export const useVerify = (): APIHookResponse => {
  const verified = useSelector(isVerified);
  const error = useSelector(verifiedError);
  const loading = verified === null && error === null;
  const apiState = {
    loading,
    data: verified,
    error,
  };
  return apiState;
};
